import React, { Component } from "react";
import "../../styles/legal_terms/legal_terms.css";

class LegalNotice extends Component {
  render() {
    return (
        <div className="legal-terms-container">
            <article>
                <h1>Aviso legal </h1>
                <p>
                    Bienvenido al sitio web de NOI Donostia. Al acceder y utilizar este sitio web, usted acepta cumplir con los siguientes términos y condiciones de uso. Por favor, lea detenidamente este aviso legal antes de continuar navegando en nuestro sitio.
                    NOI Donostia es una empresa dedicada a proporcionar servicios de estética, especialmente enfocados en el cuidado y embellecimiento de las uñas. Nuestro objetivo es ofrecer a nuestros clientes una experiencia excepcional y resultados de alta calidad.
                    Todo el contenido de este sitio web tiene propósitos informativos y no constituye asesoramiento profesional. Nos esforzamos por mantener la información actualizada y precisa, pero no garantizamos la exactitud, integridad o actualidad de la misma.
                    Al navegar por nuestro sitio web, usted acepta que NOI Donostia no será responsable por cualquier daño directo, indirecto, incidental, consecuente o punitivo que pueda surgir del uso o la incapacidad de utilizar este sitio web.
                    Nos reservamos el derecho de realizar cambios en este aviso legal en cualquier momento y sin previo aviso. Le recomendamos que revise esta página regularmente para estar al tanto de cualquier actualización.
                    Si tiene alguna pregunta o inquietud sobre este aviso legal, por favor contáctenos a través de la información proporcionada en la sección de contacto.
                    <br/>
                    Gracias por visitar nuestro sitio web.
                </p>
            </article>
        </div>
      );
  }
}

export default LegalNotice;